import type { AuthUser } from "~/core/domain/services/i-auth-adapter";

const isMockAuthEnabled = (flag?: string): boolean =>
  flag === "true" || flag === "1";

const clientFlag =
  typeof import.meta !== "undefined" && typeof import.meta.env !== "undefined"
    ? import.meta.env.VITE_MOCK_AUTH
    : undefined;

const serverFlag =
  typeof process !== "undefined" && process.env
    ? process.env.VITE_MOCK_AUTH
    : undefined;

export const IS_MOCK_AUTH_CLIENT = isMockAuthEnabled(clientFlag);
export const IS_MOCK_AUTH_SERVER = isMockAuthEnabled(serverFlag);

export function getMockAuthUser(): AuthUser {
  const env =
    typeof process !== "undefined" && process.env
      ? process.env
      : ({} as { [key: string]: string | undefined });
  return {
    id: env.VITE_MOCK_AUTH_USER_ID ?? "00000000-0000-0000-0000-000000000000",
    email: env.VITE_MOCK_AUTH_USER_EMAIL ?? "mock-user@example.com",
  };
}
